import { render, staticRenderFns } from "./sceneDetail.vue?vue&type=template&id=da1a04a0"
import script from "./sceneDetail.vue?vue&type=script&lang=js"
export * from "./sceneDetail.vue?vue&type=script&lang=js"
import style0 from "./sceneDetail.vue?vue&type=style&index=0&id=da1a04a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports